import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 2rem;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;

export const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  position: relative;
`;

export const InputLabel = styled.label`
  color: #c9c7d1;
`;

export const InputBox = styled.input`
  width: 100%;
  background-color: #18171c;
  padding: 0 1.6rem;
  border: 0.1rem solid #4d495a;
  border-radius: 0.8rem;
  height: 5.4rem;
  ::placeholder {
    color: #5c576b;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2.1rem;
  }
`;

export const InputIconBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  span {
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translate(50%, -50%);
  }
`;

export const TextArea = styled.textarea`
  background-color: #18171c;
  height: 16rem;
  padding: 1.6rem 1.6rem 0 1.6rem;
  border: 0.1rem solid #4d495a;
  border-radius: 0.8rem;
  ::placeholder {
    color: #5c576b;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2.1rem;
  }
`;

export const MaxLength = styled.div`
  color: #9170f2;
  font-size: 1.2rem;
  line-height: 2.4rem;
`;

export const Title = styled.input`
  background-color: #18171c;
  height: 3rem;
  font-size: 2.4rem;
  margin: 4rem 0 0.8rem 0;
  ::placeholder {
    color: #5c576b;
    font-size: 2.4rem;
    font-style: normal;
    font-weight: 700;
    line-height: 3rem;
  }
`;
export const ButtonBox = styled.div`
  // position: fixed;
  // bottom: 60px;
  margin: 0 auto;
  // left: 0;
  // right: 0;
  width: 100%;
  max-width: 50rem;
  padding: 2rem;
  display: flex;
  gap: 1.2rem;
`;

export const DataInputWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const DataInputBox = styled.div`
  width: 100%;
  background-color: #1f1e25;
  display: flex;
  padding: 1.6rem;
  border-radius: 0.8rem;
  flex-direction: column;
  gap: 2rem;
`;

export const ToggleLabel = styled.span`
  with: 100%;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
`;

export const ToggleWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const Toggle = styled.div<{ isToggleOn: boolean }>`
  transition: all 0.3s;
  position: relative;
  width: 3.4rem;
  height: 2rem;
  border-radius: 1rem;
  padding: 0.2rem;
  ${props =>
    props.isToggleOn
      ? 'background-color: #7750E9'
      : 'background-color: #383441'};
`;

export const ToggleButton = styled.div<{ isToggleOn: boolean }>`
  transition: all 0.3s;
  display: block;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 1.6rem;
  background-color: ${props => (props.isToggleOn ? 'white' : '#5c576b')};
  transform: ${props =>
    props.isToggleOn ? 'translateX(1.4rem)' : 'translateX(0)'};
`;

export const ToggleBox = styled.div`
  background-color: #1f1e25;
  display: flex;
  justify-content: space-between;
`;

export const ImageItemContainer = styled.div`
  position: relative;
  width: 10rem;
  height: 10rem;
  border: 0.1rem solid #4d495a;
  border-radius: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const Upload = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c8399;
  gap: 0.3rem;
`;

export const UploadText = styled.span`
  margin-bottom: 0.4rem;
  font-size: 14px;
`;

export const UploadButton = styled.button`
  border: none;
  background: transparent;
  color: #8c8399;
  font-size: 24px;
  cursor: pointer;
`;

export const FileInput = styled.input`
  display: none; /* 파일 입력 필드는 숨김 */
`;

export const InputImageBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  padding-top: 3.2rem;
`;

export const InputWrap = styled.div`
  display: flex;
  gap: 0.8rem;
`;

export const DataInput = styled.div`
  padding: 0 1.4rem;
  display: flex;
  gap: 0.8rem;
  align-items: center;
  border-radius: 0.8rem;
  border: 1px solid var(--gray-400---border3, #4d495a);
`;
